
export default function PlatformSupport() {
  const platforms = [
    {
      icon: 'ri-windows-line',
      name: 'Windows',
      description: 'Windows 10及以上版本',
    },
    {
      icon: 'ri-apple-line',
      name: 'macOS',
      description: 'macOS 10.15及以上版本',
    },
    {
      icon: 'ri-ubuntu-line',
      name: 'Linux',
      description: 'Ubuntu、CentOS、RHEL等主流发行版',
    },
    {
      icon: 'ri-cloud-line',
      name: 'Cloud',
      description: 'AWS、Azure、Google Cloud等云平台',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            跨平台支持
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            在您选择的任何平台上部署和运行
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {platforms.map((platform) => (
            <div
              key={platform.name}
              className="bg-white p-8 rounded-xl text-center hover:shadow-lg transition-all duration-300 hover:scale-105"
            >
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${platform.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {platform.name}
              </h3>
              <p className="text-gray-600">
                {platform.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
